


















import Vue from 'vue';

import {NavItems} from '@/typings/types';


export default Vue.extend({
  name: 'site-footer',
  data () {
    return {
      currentYear: new Date().getFullYear(),
      footerLinks: <NavItems[]> [
        {title: 'Home', hash: '#hero'},
        {title: 'About', hash: '#about'},
        {title: 'Services', hash: '#services'},
        {title: 'testimonials', hash: '#testimonials'},
        {title: 'Gallery', hash: '#gallery'},
        {title: 'Contact Me', hash: '#contact'},
      ],
    };
  },
});
